/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signOutUser } from '../firebase/authService';
import FeatherIcon from 'feather-icons-react';
import '../Assets/css/modern-dashboard.css';

const MENU_ITEMS = [
  { type: 'label', text: 'Main' },
  { label: 'Dashboard', path: '/admin-dashboard', icon: 'grid', activeKey: 'admin-dashboard' },

  { type: 'label', text: 'Events' },
  { label: 'Events', path: '/informationcard', icon: 'calendar', activeKey: 'informationcard' },
  { label: 'Registrations', path: '/event-registrations', icon: 'user-check', activeKey: 'event-registrations' },
  { label: 'Weekly Program', path: '/weeklyrepresentationheader', icon: 'repeat', activeKey: 'weeklyrepresentationheader' },
  { label: 'Monthly Program', path: '/representationdates', icon: 'bar-chart-2', activeKey: 'courseContent' },

  { type: 'label', text: 'Content' },
  { label: 'Hero Carousel', path: '/herocarousel', icon: 'monitor', activeKey: 'childEmergency' },
  { label: 'News', path: '/blogview', icon: 'file-text', activeKey: 'blog-details' },
  { label: 'Gallery', path: '/galleryheader', icon: 'image', activeKey: 'galleryheader' },
  { label: 'Forms', path: '/formheader', icon: 'clipboard', activeKey: 'formheader' },
  { label: 'Contact Page', path: '/contactus-background', icon: 'map-pin', activeKey: 'contactus-background' },
  { label: 'ToDos', path: '/todos-background', icon: 'check-square', activeKey: 'todos-background' },

  { type: 'label', text: 'Organization' },
  { label: 'About Us', path: '/aboutlist', icon: 'info', activeKey: 'aboutlist' },
  { label: 'About Content', path: '/importantinformationheader', icon: 'book-open', activeKey: 'importantinformationheader' },
  { label: 'Partners', path: '/serviceheader', icon: 'award', activeKey: 'serviceheader' },
  { label: 'Team', path: '/teamheader', icon: 'users', activeKey: 'teamheader' },

  { type: 'label', text: 'Comms' },
  { label: 'Social Accounts', path: '/sociallinks', icon: 'share-2', activeKey: 'sociallinks' },
  { label: 'Subscribers', path: '/subscribers', icon: 'mail', activeKey: 'subscribers' },

  { type: 'label', text: 'Contact' },
  { label: 'Contact Info', path: '/contactinfo', icon: 'phone', activeKey: 'settings' },
  { label: 'Submissions', path: '/contactsubmissions', icon: 'message-circle', activeKey: 'contact-submissions' },
];

const Sidebar = (props) => {
  const navigate = useNavigate();
  const activeClassName = props?.activeClassName;

  const handleLogout = async () => {
    try {
      await signOutUser();
      navigate('/login');
    } catch (error) {
      console.error('Failed to logout', error);
    }
  };

  const expandMenu = () => document.body.classList.remove('expand-menu');
  const expandMenuOpen = () => document.body.classList.add('expand-menu');

  return (
    <div className="sidebar" id="sidebar">
      <div className="sidebar-inner slimscroll">
        <div
          id="sidebar-menu"
          className="sidebar-menu"
          onMouseLeave={expandMenu}
          onMouseOver={expandMenuOpen}
        >
          <div className="sidebar-scroll-area">
            <ul className="sidebar-menu-flat">
              {MENU_ITEMS.map((item, idx) => {
                if (item.type === 'label') {
                  return (
                    <li key={`label-${idx}`} className="sidebar-group-label">
                      {item.text}
                    </li>
                  );
                }
                const isActive = activeClassName === item.activeKey;
                return (
                  <li key={item.activeKey} className={`sidebar-nav-item ${isActive ? 'active' : ''}`}>
                    <Link to={item.path}>
                      <FeatherIcon icon={item.icon} size={16} />
                      <span>{item.label}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>

            <div className="sidebar-footer">
              <button onClick={handleLogout} className="sidebar-logout-btn">
                <FeatherIcon icon="log-out" size={14} />
                <span>Sign out</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
